import { gql } from '@apollo/client';

import { FileDocFragment, VideoFileDocFragment } from '@modules/shared/graphql';

export const SubjectSingleFragment = gql`
    fragment SubjectSingle on OLSubject {
        id
        name
        text
        courseId
        createdAt
        sort
        test {
            questionsCount
            duration
        }
        testEnabled
        lectures {
            id
            name
            text
            createdAt
            type
            docs {
                ...FileDoc
            }
        }
        videos {
            ...VideoFileDoc
        }
        userTest {
            id
            resultSuccess
        }
        testQuestions {
            id
        }
    }
    ${FileDocFragment}
    ${VideoFileDocFragment}
`;
